export default __webpack_public_path__ + "static/media/barilla.6dfb2a10.png";